import { GhgEmissionCalculationType } from './GhgEmissionCalculationType'

export const GhgEmissionRequiredInputMap: Map<GhgEmissionCalculationType, string[]> = new Map([
  ['tonkilo', ['weight', 'distance']],
  ['modifiedTonkilo', ['weight', 'distance', 'loadRate', 'maxWeightCapacity']],
  ['fuelEfficiency', ['vehicleUsageType', 'distance']],
  ['fuel', ['fuelConsumption']],
])
